import { selectLocationPath } from './statusSelector'
import {
  selectCategoryById,
  selectCategoryBySlug,
  selectCategoryHierarchy,
} from './categoriesSelector'
import {
  selectUserWhitelistedCategoryIds,
  selectUserWhitelistedTagIds,
} from './userSelector'
import {
  brandForCategorySlugs,
  brandForPersonalSelections,
  brandForTagSlug,
  ilUutisboksiCategoriesForSlugs,
} from '../lib/trafficSteering'

const EMPTY_SLUG_CHAIN = []

function tagSlugById(state, tagId) {
  const tags = state?.tags?.tags || []
  const tag = tags.find((record) => record.id === tagId)
  return tag ? tag.slug : null
}

function slugChainForCategory(state, category) {
  if (!category) return EMPTY_SLUG_CHAIN
  return [...(selectCategoryHierarchy(state, category) || [])].map((cat) => cat.slug)
}

/**
 * Root-to-leaf slugs for a category page. Empty on home, tags, /omat, and unknown paths.
 * @returns {string[]}
 */
export function selectCategorySlugChainForCurrentPage(state) {
  const path = selectLocationPath(state) || ''
  if (!path || path === '/' || path === '/omat' || path.startsWith('/t/')) {
    return EMPTY_SLUG_CHAIN
  }

  const slug = path.startsWith('/') ? path.slice(1) : path
  if (!slug || slug.includes('/')) {
    return EMPTY_SLUG_CHAIN
  }

  return slugChainForCategory(state, selectCategoryBySlug(state, slug))
}

/**
 * ILUutisboksi `categories` prop for the current page. Returns a shared array reference
 * so useSelector does not see a new value on every render.
 * @returns {string[]|undefined}
 */
export function selectTrafficSteeringIlCategories(state) {
  return ilUutisboksiCategoriesForSlugs(selectCategorySlugChainForCurrentPage(state))
}

/**
 * Partner brand for the current page, or null if no contextual box should show.
 * @returns {'etuovi'|'nettiauto'|'iltalehti'|'kauppalehti'|null}
 */
export function selectTrafficSteeringBrand(state) {
  const path = selectLocationPath(state) || ''
  if (!path) {
    return null
  }

  if (path === '/omat') {
    const tagSlugs = [...(selectUserWhitelistedTagIds(state) || [])]
      .map((id) => tagSlugById(state, id))
      .filter((slug) => slug != null)

    const categorySlugChains = [...(selectUserWhitelistedCategoryIds(state) || [])]
      .map((id) => slugChainForCategory(state, selectCategoryById(state, id)))
      .filter((chain) => chain.length > 0)

    return brandForPersonalSelections({ tagSlugs, categorySlugChains })
  }

  if (path.startsWith('/t/')) {
    return brandForTagSlug(path.slice(3))
  }

  const chain = selectCategorySlugChainForCurrentPage(state)
  if (chain.length === 0) {
    return null
  }

  return brandForCategorySlugs(chain)
}
